import { useQuery } from '@tanstack/react-query'

import { LayoutReactQueryKeys } from '@/components/header/types'

import fetchRequest from './fetch-request'

const useGetCartCount = () => {
    const { data: cartCount, isLoading } = useQuery({
        queryKey: [LayoutReactQueryKeys.CartCount],
        queryFn: () => fetchRequest({ serviceName: 'ntl', endpoint: '/carts/_my/items/count', method: 'GET' }),
    })

    return { isLoading, cartCount }
}

export default useGetCartCount
